<template>
  <main-layout>
    <div class="welcome">
      <h1>Submission Successful!<br />Thank you for choosing Greendoor.</h1>
      <div>
        We will contact you in 1 - 2 business days to review your China page
        together with you.
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/layout/main';
export default {
  components: { MainLayout },
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {},
};
</script>
<style lang="less" scoped>
.welcome {
  width: 80%;
  min-width: 375px;
  margin: 0 auto;
  h1 {
    font-size: 36px;
  }
  div {
    font-size: 18px;
  }
  .btns {
    text-align: center;
    padding-top: 160px;
  }
}
</style>
